import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import Auth0 from '../../../../../../../../store/actions/auth/Auth'
import { actionCreators as fileProgressActionCreators } from '../../../../../../../../data/fileProgress/actions';
import { authErrorMessages } from '../../../../../../../../components/FormHelpers/authErrorCodes';

const { setUploadStatus, setUploadProgress, setUploadData, setUploadComplete } = fileProgressActionCreators;

export const getDocuments = createAsyncThunk(
  'documents/getDocuments',
  async () => {
    const response = await axios.get('api/admin/documents', {
      headers: { "Authorization": `Bearer ${Auth0.getAccessToken()}` }
    });
    return response.data;
  }
);

export const actionCreators = {
  getDocuments,
  postFile: (file, deliveryId) => async (dispatch) => {
    dispatch(setUploadData({ 
      name: file.name, 
      deliveryId,
      size: file.size,
      type: file.type,
    }));

    dispatch(setUploadStatus({ 
      name: file.name,
      status: 'active',
    }));

    let fileToBeSent = new FormData();

    // For small files (<= 50 MB), read into memory first to avoid OneDrive/network-share
    // streaming issues that cause ERR_FAILED with no HTTP response.
    // For large files, fall back to direct streaming to avoid exhausting browser RAM.
    const IN_MEMORY_THRESHOLD = 50 * 1024 * 1024; // 50 MB
    if (file.size <= IN_MEMORY_THRESHOLD) {
      try {
        const fileBuffer = await file.arrayBuffer();
        const uploadBlob = new Blob([fileBuffer], { type: file.type || 'application/octet-stream' });
        fileToBeSent.append('file', uploadBlob, file.name);
      } catch (err) {
        const errorMessage = 'Filen kan inte läsas, prova stänga filen om den är öppen.';
        dispatch(setUploadStatus({ name: file.name, status: 'exception', errorMessage }));
        throw err;
      }
    } else {
      fileToBeSent.append('file', file, file.name);
    }

    return axios.post(`/api/files?deliveryId=${deliveryId}`, fileToBeSent, {
      onUploadProgress: (progressEvent) => {
        dispatch(setUploadProgress({
          name: file.name,
          progress: parseInt((100 * progressEvent.loaded) / progressEvent.total)
        }));
      },
      headers: { 'Content-Type': 'multipart/form-data', "Authorization": `Bearer ${Auth0.getAccessToken()}`}
    })
    .then(response => {
      dispatch(setUploadStatus({ name: file.name, status: 'success' }));
      return response;
    })
    .catch(async err => {
      const errorCode = err?.response?.data?.errorCode;
      const match = authErrorMessages.find(({ errorCode: code }) => code === errorCode);
      let errorMessage = match?.errorMessage || 'Uppladdningen misslyckades';

      // No HTTP response means transport/proxy failure before the API returned a status code.
      if (!err?.response) {
        errorMessage = 'Uppladdningen misslyckades pga natverksfel. Forsok igen.';
      }

      dispatch(setUploadStatus({ name: file.name, status: 'exception', errorMessage }));
      throw err;
    });
  },
  uploadComplete: (deliveryId) => async (dispatch, getState) => {
    const { fileProgress } = getState();
    const allFilesUploaded = Object.values(fileProgress)
      .filter(Boolean)
      .every(({ status }) => status === 'success');

    if (allFilesUploaded) {
      try {
        await axios.post(`/api/admin/deliveries/toCustomer/${deliveryId}/uploadComplete`, {}, {
          headers: { "Authorization": `Bearer ${Auth0.getAccessToken()}` }
        });
      
        dispatch(setUploadComplete(true));
        
      } catch (err) {
        console.error('Upload complete failed:', err);
      }
    }
  }
};